import { learningApi } from 'services/api'
import { mutate } from 'swr'
import { StudentDoubt } from '../types'

export const DELETE_NOTIFICATION = async (query: string) => {
  const token = localStorage.getItem('token')
  try {
    await learningApi.delete(`/notification/question/${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    mutate('/notification')
  } catch (err) {
    console.log(err)
  }
}

export const NEW_MESSAGE_DOUBT = async (query: string, newDate: StudentDoubt) => {
  const token = localStorage.getItem('token')
  try {
    await learningApi.put(`/asking/${query}`, newDate, {
      headers: { Authorization: `Bearer ${token}` },
    })

    mutate(`/asking/${query}`)
  } catch (err) {
    console.log(err)
  }
}
